import ExhibitionCard from 'components/cards/exhibition-card';
import PublicationCard from 'components/publications/publication-card';
import ShelfSubsection from 'components/containers/shelf/shelf-subsection';
import ArticleCard, {
	type ArticleCardProps,
} from 'components/cards/article-card';
import { routeForDocument } from '@metmuseum/routes';
import styles from '../collection-object-package-page.module.scss';
import type {
	ArticleCardData,
	ISanityExhibitionData,
	RelatedEssay,
	RelatedPublication,
} from '@metmuseum/types';

export default function RelatedContentTabPanel({
	relatedContent,
}: RelatedContentTabPanelProps) {
	const { essays, articles, publications, exhibitions } = relatedContent;

	return (
		<div className={styles.tabPanelContent}>
			{articles?.length > 0 && (
				<ShelfSubsection title="Articles, Audio, and Video">
					{articles.map((article) => (
						<ShelfArticleCard
							contentType={article._type}
							key={article._id}
							title={article.title}
							textDescription={article.subtitle}
							image={article.cardImage}
							date={article.publicationDate}
							type={article.type}
							comingSoon={article._type == 'placeholderArticle'}
							contributors={article.contributors}
							link={routeForDocument(article)}
						/>
					))}
				</ShelfSubsection>
			)}
			{essays?.length > 0 && (
				<ShelfSubsection title="Essays">
					{essays.map((essay) => (
						<ShelfArticleCard
							contentType={essay._type}
							key={essay._id}
							title={essay.title}
							textDescription={essay.subtitle}
							image={essay.cardImage}
							date={essay.publicationDate}
							contributors={essay.contributors}
							link={routeForDocument(essay)}
						/>
					))}
				</ShelfSubsection>
			)}
			{publications?.length > 0 && (
				<ShelfSubsection title="Publications">
					{publications.map((publication) => (
						<PublicationCard publication={publication} key={publication._id} />
					))}
				</ShelfSubsection>
			)}
			{exhibitions?.length > 0 && (
				<ShelfSubsection title="Exhibitions">
					{exhibitions.map((exhibition) => (
						<ExhibitionCard
							exhibition={{
								...exhibition,
								status: exhibition.exhibitionStatus,
							}}
							key={exhibition._id}
						/>
					))}
				</ShelfSubsection>
			)}
		</div>
	);
}

interface RelatedContentTabPanelProps {
	relatedContent: RelatedContent;
}

export interface RelatedContent {
	articles?: ArticleCardData[];
	essays?: RelatedEssay[];
	publications?: RelatedPublication[];
	exhibitions?: ISanityExhibitionData[];
}

// Ad hoc wrapper to allow ArticleCards to work with a shelf layout.
// Can be formalized/rethought if this comes up more often.
function ShelfArticleCard(props: ArticleCardProps) {
	const articleCardStyle = {
		flexBasis: '364px',
		flexGrow: 0,
		flexShrink: 0,
		maxWidth: 'var(--max-width-unclamped)',
		// Ensure any inline styles on the wrapper are preserved.
		...props.style,
	};

	return <ArticleCard {...props} style={articleCardStyle} />;
}
